import React from "react";
import ClickToFlyResultsContent from "../components/click-to-fly/click-to-fly-results-content";

const ClickToFlyResults = () => {
  return <ClickToFlyResultsContent />;
};

export default ClickToFlyResults;

